import React from 'react';
import classnames from 'classnames';
import bemBlock from '@gik/core/utils/bemBlock';
import { SvgIcon } from '@gik/ui';
import Link from '@/components/Link';

export interface IMarketingNavItemProps extends React.HTMLAttributes<HTMLDivElement> {
  href: string;
}

export default function MarketingNavItem({ children, href }: IMarketingNavItemProps): React.ReactElement {
  const bem = bemBlock('marketing-nav__item');
  const blockClasses = classnames([bem()]);

  return (
    <li className={blockClasses}>
      <Link href={href}>
        <a>
          <span className={bem('title')}>{children}</span>
          <div className={bem('icon')}>
            <SvgIcon name="ArrowCircleRightOutline" size="lg" />
          </div>
        </a>
      </Link>
    </li>
  );
}
